import {
    IEyeCatcherL10n,
    IFlexibleSetL10n,
    IL10nApi,
    IModalL10n,
    IPriceL10n,
    IProductFinderL10n,
    ISearchL10n,
    IVariantsL10n
} from "../../types/l10n";

export function decodeHTML(value: string): string {
    return value.replace(/&#(\d+);/g, (_match, dec) => {
        return String.fromCharCode(dec);
    });
}

export function useL10n(localization: ISearchL10n): IL10nApi {
    const l10n = localization;
    const articlesHeadline = decodeHTML(l10n.articlesSuggestHeadline);
    const contentHeadline = decodeHTML(l10n.contentSuggestHeadline);
    const topSearchQueriesHeadline = decodeHTML(l10n.topSearchQueriesHeadline);
    const seeAllResults = decodeHTML(l10n.seeAllResults);
    const defaultTerm = decodeHTML(l10n.defaultTerm);
    const imageMainView = decodeHTML(l10n.imageMainView);

    const decodeModalL10n = (): IModalL10n => {
        return {
            labelOk: decodeHTML(l10n.ok),
            labelClose: decodeHTML(l10n.close),
            dataIncomplete: decodeHTML(l10n.dataIncomplete),
            enterSearchTerm: decodeHTML(l10n.enterSearchTerm)
        };
    };

    const decodePriceL10n = (): IPriceL10n => {
        const priceL10n: IPriceL10n = {
            colon: decodeHTML(l10n.prices.colon),
            comparisonPrice: decodeHTML(l10n.prices.comparisonPrice),
            exVATAcronym: decodeHTML(l10n.prices.exVATAcronym),
            incVATAcronym: decodeHTML(l10n.prices.incVATAcronym),
            priceFromLocale: decodeHTML(l10n.prices.priceFromLocale)
        };
        return priceL10n;
    };

    const decodeVariantsL10n = (): IVariantsL10n => {
        const variantsL10n: IVariantsL10n = {
            color: decodeHTML(l10n.variants.color),
            colors: decodeHTML(l10n.variants.colors),
            variant: decodeHTML(l10n.variants.variant),
            variants: decodeHTML(l10n.variants.variants)
        };
        return variantsL10n;
    };

    const decodeProductFinderL10n = (): IProductFinderL10n => {
        const productFinderL10n: IProductFinderL10n = {
            trouserFinderHeadline: decodeHTML(l10n.finders.trouserFinderHeadline),
            trouserFinderCTA: decodeHTML(l10n.finders.trouserFinderCTA),
            trouserFinderLink: decodeHTML(l10n.finders.trouserFinderLink),
            trouserFinderShortLink: decodeHTML(l10n.finders.trouserFinderShortLink),
            trouserFinderLogo: decodeHTML(l10n.finders.trouserFinderLogo),
            jacketFinderCTA: decodeHTML(l10n.finders.jacketFinderCTA),
            jacketFinderHeadline: decodeHTML(l10n.finders.jacketFinderHeadline),
            jacketFinderLink: decodeHTML(l10n.finders.jacketFinderLink),
            jacketFinderShortLink: decodeHTML(l10n.finders.jacketFinderShortLink),
            jacketFinderLogo: decodeHTML(l10n.finders.jacketFinderLogo),
            shoeFinderCTA: decodeHTML(l10n.finders.shoeFinderCTA),
            shoeFinderHeadline: decodeHTML(l10n.finders.shoeFinderHeadline),
            shoeFinderLink: decodeHTML(l10n.finders.shoeFinderLink),
            shoeFinderShortLink: decodeHTML(l10n.finders.shoeFinderShortLink),
            shoeFinderLogo: decodeHTML(l10n.finders.shoeFinderLogo),
            productFinderLogoBasePathPreview: decodeHTML(
                l10n.finders.productFinderLogoBasePathPreview
            ),
            productFinderLogoBasePathRelease: decodeHTML(
                l10n.finders.productFinderLogoBasePathRelease
            )
        };
        return productFinderL10n;
    };

    const decodeFlexSetsL10n = (): IFlexibleSetL10n => {
        const flexibleSetsL10n: IFlexibleSetL10n = {
            article: decodeHTML(l10n.flexSets.article),
            articles: decodeHTML(l10n.flexSets.articles)
        };
        return flexibleSetsL10n;
    };
    const decodeEyeCatcherL10n = (): IEyeCatcherL10n => {
        const eyeCatcherL10n: IEyeCatcherL10n = {
            sale: decodeHTML(l10n.eyeCatcher.sale),
            setPrice: decodeHTML(l10n.eyeCatcher.setPrice)
        };
        return eyeCatcherL10n;
    };

    return {
        articlesHeadline,
        contentHeadline,
        topSearchQueriesHeadline,
        seeAllResults,
        defaultTerm,
        imageMainView,
        decodePriceL10n,
        decodeVariantsL10n,
        decodeProductFinderL10n,
        decodeModalL10n,
        decodeFlexSetsL10n,
        decodeEyeCatcherL10n
    };
}
